<template>
    <div class="cms_hirek_outer">
        <GrcDB ref="GRCDB"></GrcDB>

        <div style="width:100%; box-sizing:border-box; margin-bottom:30px; text-align:left;">
            <GrcText ref="txtSearchText"
            grc_labeltext=""
            grc_placeholder="Keresés"
            grc_labelmode="nolabel" grc_labelwidth="200px" 
            v-on:grc-keydown-enter="btnKeres_click"
            style="margin-bottom:20px; margin-right:4px; display:inline-block; vertical-align:top; width:260px;"
            />

            <span class="cms_linkbutton cms_linkbutton_2" style="vertical-align:top; cursor:pointer;" @click="btnKeres_click"><i class="fas fa-search" style="margin-right:0px;"></i></span>            

        </div>

        <div class="cms_hirek_listcont">
            <a v-for="(item, index) in LIST" :key="index" class="cms_hirek_item" v-html="item.HtmlContent" :href="item.Alias">
            </a>
        </div>

        <div class="cms_hirek_norecord" v-show="LIST.length==0">Nincs a feltételeknek megfelelő bejegyzés</div>


    </div>
</template>

<script>

import GrcDB from '../GrcComponents/GrcDB.vue'
import GrcText from '../GrcComponents/GrcText.vue'

export default {
  name: 'frmblog',
  components: {
    GrcDB,
    GrcText,
  },

  data () {
        return {
            LIST:[],
        }
  },
  model: {

  },  
  methods:{

    async Init()
    {
        this.Kereses("");
    },

    btnKeres_click()
    {
        this.Kereses(this.$refs.txtSearchText.GetInnerText().trim());
    },

    async Kereses(pText)
    {
        var QP = {
            sSessionID: "[APPSESSIONID]",
            sSearchText: pText,
        };
        var Q;
        await this.$refs.GRCDB.GetData("frmBlog_GetData", QP).then(res => { Q = res; });

        if (Q.APPERR[0].ERR != "")
        {
            console.log(Q);
            return;
        }

        this.LIST = Q.LIST;

    },

  },
  created()
  {
    
  },

 mounted()
 {
    this.Init();
 },


}


</script>


<style scoped>


</style>
